module.exports = __webpack_public_path__ + "img/icons8-person-job.6120232a.svg";